import pl from "@locales/program_schedule/pl.json";
import en from "@locales/program_schedule/en.json";
export default {
  pl: pl,
  en: en,
};
